import App from './App'

(function ($) {
  Drupal.ca_file_gallery = Drupal.ca_file_gallery || {}
  Drupal.ca_file_gallery.groups = Drupal.ca_file_gallery.groups || {}

  const groups = Drupal.ca_file_gallery.groups

  Drupal.behaviors.ca_file_gallery = {

    attach: function (context, settings) {

      $('.ca-file-gallery-item, .field-name-body img.gallery-item', context).once('ca-gallery', function () {
        const key = $(this).attr('ca-gallery-group') || 'default'
        groups[key] = groups[key] || {}
        groups[key]['items'] = groups[key]['items'] || []
        groups[key]['items'].push(this)
      })

      if (!window.Vue) {
        console.warn('No Vue.js found')
        return;
      }

      Vue.use(Vuetify)

      for (let key in groups) {

        if (!groups.hasOwnProperty(key) || document.getElementById(key + '-wrapper')) continue

        let elem = '<div class="file-gallery-wrapper" id="' + key + '-wrapper"><div id="' + key + '"></div></div>'
        $('#app').append(elem)

        if (!groups[key].vm) {
          groups[key].vm = new Vue({
            el: '#' + key,
            render: function (h) {
              return h(App, {
                props: {
                  items: groups[key].items
                }
              })
            },
          })
        }
      }
    },

    detach: function (context, settings, trigger) {
      if (trigger === 'unload') {
        $('.ca-file-gallery-item', context).each(function() {
          const key = $(this).attr('ca-gallery-group')
          if (groups[key] && groups[key].vm) {
            groups[key].vm.$destroy()
            delete groups[key]
          }

          $('#' + key + '-wrapper').remove()
        });
      }
    }
  }

})(jQuery)
